module.exports = __webpack_public_path__ + "static/media/search.b7e8bfe5.svg";